import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ArrowBack from '@mui/icons-material/ArrowBackIos';
import ArrowForward from '@mui/icons-material/ArrowForwardIos';
import { Card, Grid, Button, Stepper, Step, StepButton, StepLabel, useTheme, useMediaQuery } from '@mui/material';

const StepperComponent = ({
  steps,
  activeStep,
  onStepClick,
  onPreviousStepClick,
  previousStepDisabled,
  onNextStepClick,
  nextStepDisabled
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const overMd = useMediaQuery(theme.breakpoints.up('md'));

  const handleStepChange = useCallback(step => () => onStepClick(step), [onStepClick]);

  return (
    <Card disablepadding='true' sx={{ p: 2, mb: 2 }}>
      <Grid container alignItems='center' spacing={3}>
        {overMd && (
          <Grid item>
            <Button id={'offerStepper_previousBtn'} disabled={previousStepDisabled()} onClick={onPreviousStepClick}>
              <ArrowBack />
              {t('Previous')}
            </Button>
          </Grid>
        )}

        <Grid item xs>
          <Grid container>
            <Grid item xs={12}>
              <Stepper activeStep={activeStep} orientation='horizontal'>
                {steps.map(step => (
                  <Step key={step.code}>
                    <StepButton
                      id={'offerStepper_' + t(step.title).toLowerCase()}
                      disabled={step.disabled}
                      onClick={handleStepChange(step)}
                    >
                      <StepLabel sx={{ pointerEvents: 'none' }}>{t(step.title)}</StepLabel>
                    </StepButton>
                  </Step>
                ))}
              </Stepper>
            </Grid>
          </Grid>
        </Grid>

        {overMd && (
          <Grid item>
            <Button id={'offerStepper_nextBtn'} color='primary' disabled={nextStepDisabled()} onClick={onNextStepClick}>
              {t('Next')}
              <ArrowForward />
            </Button>
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

StepperComponent.propTypes = {
  steps: PropTypes.array.isRequired,
  activeStep: PropTypes.number.isRequired,
  onStepClick: PropTypes.func.isRequired,
  onPreviousStepClick: PropTypes.func.isRequired,
  previousStepDisabled: PropTypes.func.isRequired,
  onNextStepClick: PropTypes.func.isRequired,
  nextStepDisabled: PropTypes.func.isRequired
};

export default StepperComponent;
